import { helpers, mui, React, ts, ui } from '_core';

import { Params } from './types';
type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  fileEvent: string;
  fullScreen: boolean;
  params: Params;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, fileEvent, fullScreen, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);
  const [selectedTab, setSelectedTab] = React.useState<'error' | 'tstat'>('error');

  const loadData = async (selectedTab: 'error' | 'tstat') => {
    try {
      const response = await loadWidgetData({
        data: {
          file: fileEvent,
          rename: selectedTab == 'error' ? { avg_cum: 'average_cumulative_return', std_cum: 'error' } : {},
          columns: selectedTab == 'tstat' ? ['days_from_event', 'tstat'] : undefined,
        },
      });
      if (response) setData(response.data);
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (fileEvent) loadData(selectedTab);
    return () => setData(null);
  }, [fileEvent, selectedTab]);

  const getTabs = () => (
    <mui.core.Tabs
      indicatorColor="primary"
      textColor="primary"
      value={selectedTab}
      onChange={(_e, newTab) => setSelectedTab(newTab)}
    >
      <mui.core.Tab label="Cumulative Returns with Error" value="error" />
      <mui.core.Tab label="T-stat" value="tstat" />
    </mui.core.Tabs>
  );

  const renderChart = () => {
    if (selectedTab == 'error') {
      return (
        <ui.ErrorChart
          id={id}
          data={data}
          fullScreen={fullScreen}
          readOnly={readOnly}
          alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
          xAxisField="days_from_event"
          yAxisField="average_cumulative_return"
          xAxisLabel="Days"
          yAxisLabel="Mean Cumulative Returns (%)"
          exportTitle={title}
        />
      );
    }

    if (selectedTab == 'tstat') {
      return (
        <ui.NestedBarChart
          id={id}
          data={data}
          fullScreen={fullScreen}
          readOnly={readOnly}
          alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
          yAxisLabel="T-stat"
          xAxisLabel="Days"
          category="days_from_event"
          exportTitle={title}
        />
      );
    }

    return null;
  };

  return (
    <mui.core.Box display="flex" flexDirection="column" height="100%">
      {getTabs()}
      <mui.core.Box flexGrow={1}>{renderChart()}</mui.core.Box>
    </mui.core.Box>
  );
};

export default Chart;
